export enum Segmento {
  IndumentariaYCalzado = "1",
  ImplementosAgricolas = "2",
  AlimentosYBebidas = "3",
  ArtDelHogar = "4",
  PintureriasYFerreterias = "5",
  TalleresMecanicosYOtros = "6",
  DistribuidoresYMayoristas = "7",
  ServiciosPublicos = "8",
  MediosDeComunicacion = "9",
  Estacionamientos = "10",
  InsumosAgricolasGanaderos = "11",
  ContadoresYGestores = "12",
  ServiciosAgropecuarios = "13",
  Construccion = "14",
  Seguros = "15",
  ProductoresDeAlimentos = "16",
  Gastronomia = "17",
  Panaderias = "18",
  LibreriasEImprentas = "19",
  Carpinterias = "20",
  ServiciosDeMantenimientoYReparacion = "21",
  ArtLimpiezaEHigiene = "22",
  KioskosYPolirubros = "23",
  Veterinarias = "24",
  ServiciosMedicos = "25",
  EntidadesFinancieras = "26",
  IndustriaPlastica = "27",
  CombustiblesYLubricantes = "28",
  Otros = "29",
  FarmaciasYPerfumerias = "30",
  Hoteles = "31",
  ProdAgropecuario = "32",
  TecnologiaYComputacion = "33",
  Instituciones = "34",
  ArtElectricidad = "35",
  ConcesionariasDeAutomotores = "36",
  AbogadosYEscribanos = "37",
  Arquitectos = "38",
  ServiciosDeTransporte = "39",
  ServiciosInmobiliarios = "40",
  Turismo = "41",
  Mercerias = "42",
  Eventos = "43",
  Opticas = "44",
  ClubesDeportivosYGimnasios = "45",
  ServiciosDeFumigaciones = "46",
  Viveros = "47",
  VentaDeMotoresRepuestos = "48",
  JoyeriaYRelojeria = "49",
  AgenciasDeLoteria = "50",
  Heladerias = "51",
  Consultoria = "52",
  CentrosDeEstetica = "53",
  Veterinarios = "54",
}

export const SegmentoNombre: Record<Segmento, string> = {
    [Segmento.IndumentariaYCalzado]: 'Indumentaria y Calzado',
    [Segmento.ImplementosAgricolas]: 'Implementos Agrícolas',
    [Segmento.AlimentosYBebidas]: 'Alimentos y Bebidas',
    [Segmento.ArtDelHogar]: 'Art. del Hogar',
    [Segmento.PintureriasYFerreterias]: 'Pinturerías y Ferreterías',
    [Segmento.TalleresMecanicosYOtros]: 'Talleres Mecánicos y Otros',
    [Segmento.DistribuidoresYMayoristas]: 'Distribuidores y Mayoristas',
    [Segmento.ServiciosPublicos]: 'Servicios Públicos',
    [Segmento.MediosDeComunicacion]: 'Medios de Comunicación',
    [Segmento.Estacionamientos]: 'Estacionamientos',
    [Segmento.InsumosAgricolasGanaderos]: 'Insumos Agrícolas Ganaderos',
    [Segmento.ContadoresYGestores]: 'Contadores y Gestores',
    [Segmento.ServiciosAgropecuarios]: 'Servicios Agropecuarios',
    [Segmento.Construccion]: 'Construcción',
    [Segmento.Seguros]: 'Seguros',
    [Segmento.ProductoresDeAlimentos]: 'Productores de Alimentos',
    [Segmento.Gastronomia]: 'Gastronomía',
    [Segmento.Panaderias]: 'Panaderías',
    [Segmento.LibreriasEImprentas]: 'Librerías e Imprentas',
    [Segmento.Carpinterias]: 'Carpinterías',
    [Segmento.ServiciosDeMantenimientoYReparacion]: 'Servicios de Mantenimiento y Reparación',
    [Segmento.ArtLimpiezaEHigiene]: 'Art. Limpieza e Higiene',
    [Segmento.KioskosYPolirubros]: 'Kioskos y Polirubros',
    [Segmento.Veterinarias]: 'Veterinarias',
    [Segmento.ServiciosMedicos]: 'Servicios Médicos',
    [Segmento.EntidadesFinancieras]: 'Entidades Financieras',
    [Segmento.IndustriaPlastica]: 'Industria Plástica',
    [Segmento.CombustiblesYLubricantes]: 'Combustibles y Lubricantes',
    [Segmento.Otros]: 'Otros',
    [Segmento.FarmaciasYPerfumerias]: 'Farmacias y Perfumerías',
    [Segmento.Hoteles]: 'Hoteles',
    [Segmento.ProdAgropecuario]: 'Prod. Agropecuario',
    [Segmento.TecnologiaYComputacion]: 'Tecnología y Computación',
    [Segmento.Instituciones]: 'Instituciones',
    [Segmento.ArtElectricidad]: 'Art. Electricidad',
    [Segmento.ConcesionariasDeAutomotores]: 'Concesionarias de Automotores',
    [Segmento.AbogadosYEscribanos]: 'Abogados y Escribanos',
    [Segmento.Arquitectos]: 'Arquitectos',
    [Segmento.ServiciosDeTransporte]: 'Servicios de Transporte',
    [Segmento.ServiciosInmobiliarios]: 'Servicios Inmobiliarios',
    [Segmento.Turismo]: 'Turismo',
    [Segmento.Mercerias]: 'Mercerías',
    [Segmento.Eventos]: 'Eventos',
    [Segmento.Opticas]: 'Ópticas',
    [Segmento.ClubesDeportivosYGimnasios]: 'Clubes Deportivos y Gimnasios',
    [Segmento.ServiciosDeFumigaciones]: 'Servicios de Fumigaciones',
    [Segmento.Viveros]: 'Viveros',
    [Segmento.VentaDeMotoresRepuestos]: 'Venta de Motores y Repuestos',
    [Segmento.JoyeriaYRelojeria]: 'Joyería y Relojería',
    [Segmento.AgenciasDeLoteria]: 'Agencias de Lotería',
    [Segmento.Heladerias]: 'Heladerías',
    [Segmento.Consultoria]: 'Consultoría',
    [Segmento.CentrosDeEstetica]: 'Centros de Estética',
    [Segmento.Veterinarios]: 'Veterinarios',
};
export function getNombreSegmento(id: number): string {
  return SegmentoNombre[id as unknown as Segmento] || 'Desconocido';
}